import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue'
import useWatchRoute from 'src/hooks/watchRoute'


import { defineComponent } from 'vue'
const __default__ = defineComponent({ name: 'BreadCrumb' })

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { route } = useWatchRoute()
const crumbs = computed(() =>
  route.value.matched
    .map((match) => {
      const breadcrumb = match?.meta.breadcrumb
      if (!breadcrumb) return null

      const query = route.value.query ?? {}

      const to = match.name
        ? { name: match.name, query }
        : breadcrumb.path ?? match.path ?? ''

      const icon = breadcrumb.icon
      const label = breadcrumb.name

      return {
        id: match.name,
        label,
        to,
        icon,
      }
    })
    .filter((b) => b != null)
)

return (_ctx: any,_cache: any) => {
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_openBlock(), _createBlock(_component_q_page_sticky, {
    expand: "",
    position: "top",
    style: {"z-index":"1","top":"0"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, { class: "bg-white breadcrumb" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_breadcrumbs, {
            "separator-color": "secondary",
            class: "q-py-md q-py-md-none"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(crumbs.value, (crumb) => {
                return (_openBlock(), _createBlock(_component_q_breadcrumbs_el, _mergeProps({
                  key: `crumb_${crumb.id}`,
                  "active-class": "text-primary"
                }, { ref_for: true }, crumb), null, 16))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})